var map = {
	"./badges/discuss.png": 435,
	"./badges/informe.png": 436,
	"./badges/look-after.png": 437,
	"./badges/report.png": 438,
	"./bg-pattern.png": 2138,
	"./corridor/friesen-avatar.png": 439,
	"./corridor/friesen.png": 375,
	"./corridor/mrs-teller-avatar.png": 440,
	"./corridor/mrs-teller.png": 370,
	"./door.png": 2139,
	"./female.png": 308,
	"./hospitalRoom/first-patient-down.png": 376,
	"./hospitalRoom/first-patient.png": 182,
	"./hospitalRoom/second-patient.png": 183,
	"./hospitalRoom/slipper.png": 266,
	"./hospitalRoom/tablet.png": 369,
	"./hospitalRoom/wheelchair.png": 267,
	"./logo-app.png": 309,
	"./logo.png": 209,
	"./male.png": 307,
	"./office/coffee-machine.png": 184,
	"./office/dietary-assistant.png": 441,
	"./office/doctor-portrait.png": 305,
	"./office/doctor.png": 373,
	"./office/lisa-back.png": 371,
	"./office/lisa-front.png": 372,
	"./office/lisa-portrait.png": 206,
	"./office/milo-portrait.png": 207,
	"./office/milo.png": 377,
	"./office/records.png": 374,
	"./patient.png": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;